import React from 'react';
import { PROBLEMS } from '../mock';

export default function Problems() {
  return (
    <section className="bg-[#f5f5f7] py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">PROBLEMY, KTÓRE ROZWIĄZUJĘ</div>
        <h2 className="font-heading font-extrabold text-[38px] md:text-[52px] leading-[1.05] tracking-tight text-[#0f1a2b] max-w-3xl">
          Potrzebujesz wsparcia na etapie inwestycji?
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PROBLEMS.map((p) => (
            <div key={p.n} className="rounded-2xl bg-white border border-slate-200 p-7 hover-lift">
              <div className="flex items-start gap-5">
                <span className="font-heading font-extrabold text-[36px] leading-none text-[#f5c518]">{p.n}</span>
                <div>
                  <h3 className="font-heading font-bold text-[18px] tracking-tight text-[#0f1a2b]">{p.title}</h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-[#0f1a2b]/70">{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
